import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./modules/auth/authSlice";
import subscriptionPlanReducer from "./modules/subscription/subscriptionPlanSlice";
import userReducer from "./modules/user/userSlice";
import activeSubscriptionReducer from "./modules/subscription/activeSubscriptionSlice";
import fieldConfigReducer from "./modules/fieldConfig/fieldConfigSlice";
import transactionYearReducer from "./modules/transactionYear/transactionYearSlice";
import transactionReducer from "./modules/transactions/transactionSlice";
import commonReducer from "./modules/common/commonSlice";
import analyticsReducer from "./modules/analytics/analyticsSlice";
import hiddenFieldReducer from "./modules/hiddenFields/hiddenFieldSlice";
import repeatsAndReferrersReducer from "./modules/repeatsAndReferrers/repeatsAndReferrersSlice";
import adminSliceReducer from "./modules/admin/adminSlice";
import financialSettingsReducer from "./modules/financialSettings/financialSettingsSlice";
import gciTrackerReducer from "./modules/gciTracker/gciTrackerSlice";
import coAgentFilterReducer from "./modules/coAgentFilter/coAgentFilterSlice";
import pageFiltersReducer from "./modules/pageFilters/pageFiltersSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  subscriptionPlan: subscriptionPlanReducer,
  user: userReducer,
  activeSubscription: activeSubscriptionReducer,
  fieldConfig: fieldConfigReducer,
  transactionYear: transactionYearReducer,
  transaction: transactionReducer,
  commonData: commonReducer,
  analytics: analyticsReducer,
  hiddenFields: hiddenFieldReducer,
  repeatsAndReferrers: repeatsAndReferrersReducer,
  admin: adminSliceReducer,
  financialSettings: financialSettingsReducer,
  gciTracker: gciTrackerReducer,
  coAgentFilter: coAgentFilterReducer,
  pageFilters: pageFiltersReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
